// ObserverBanner — shows a persistent read-only notice at the top of the page
// for users with role === 'observer'. Renders nothing for other roles.
import React from "react";
import { Eye } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const ObserverBanner = () => {
  const { user } = useAuth();
  if (!user || user.role !== "observer") return null;
  return (
    <div
      className="flex items-center gap-2 mb-4 rounded-md px-3 py-2"
      style={{
        background: "rgba(243,177,74,0.08)",
        border: "1px solid rgba(243,177,74,0.35)",
        color: "#f3b14a",
      }}
      data-testid="observer-banner"
    >
      <Eye size={14} />
      <span
        style={{
          fontFamily: "DM Mono, monospace",
          fontSize: 11,
          letterSpacing: "0.6px",
        }}
      >
        Your role has read-only access to linked incidents.
      </span>
    </div>
  );
};
